import {
  AppSettingsNavigationDTO,
  ClubClassesSettingsDTO,
} from "@gymflow/types";
import { FEAppSettingsHomePage } from "libs/helpers/src/lib/appSettings";
import { createContext } from "react";

export const AppSettingsContext = createContext<{
  navigationSettings: AppSettingsNavigationDTO;
  setNavigationSettings: (data: AppSettingsNavigationDTO) => void;
  classesSettings: ClubClassesSettingsDTO;
  setClassesSettings: (data: ClubClassesSettingsDTO) => void;
  homePageSettings: FEAppSettingsHomePage;
  setHomePageSettings: (data: FEAppSettingsHomePage) => void;
}>({} as any);
